/*
 * ERD — «Sconto App 5%»: dal sito l'attributo carrello "_canale" non deve mai arrivare al checkout
 * (snippets/endurrad-canale-sito.liquid, per tutti i visitatori).
 *
 * L'app Endurrad mette "_canale" = "app" solo mentre il cliente paga nell'app e lo toglie dopo,
 * ma con il «Carrello unico» app e sito usano lo stesso carrello: se l'app viene chiusa a metà
 * pagamento, l'attributo potrebbe restare. Qui lo togliamo (POST /cart/update.js, valore vuoto):
 *   1. al caricamento della pagina, se c'è (copre anche i pulsanti di pagamento rapido);
 *   2. al tocco su «Procedi all'acquisto» (pulsante name="checkout" o link a /checkout):
 *      prima si toglie l'attributo, poi si va al checkout come sempre.
 * Nessun dato personale nei log, nessun tracciamento. Non tocca mai righe né codici sconto.
 */
(function () {
  'use strict';

  var KEY = '_canale';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var inCorso = null;

  function json(url, body) {
    var init = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      init.method = 'POST';
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }
    return fetch(url, init).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  /** Toglie "_canale" se presente. Non fallisce mai (al massimo un avviso senza dati). */
  function togli() {
    if (inCorso) return inCorso;
    inCorso = json(root + 'cart.js')
      .then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        if (attrs[KEY] === undefined || attrs[KEY] === null || attrs[KEY] === '') return null;
        var body = { attributes: {} };
        body.attributes[KEY] = '';
        return json(root + 'cart/update.js', body);
      })
      .catch(function (e) {
        console.warn('[Endurrad] attributo canale non aggiornato (' + (e && e.message ? e.message : 'errore') + ')');
      })
      .then(function () {
        inCorso = null;
      });
    return inCorso;
  }

  function versoCheckout(el) {
    if (!el || !el.closest) return null;
    var btn = el.closest('button[name="checkout"], input[name="checkout"]');
    if (btn) return { tipo: 'pulsante', el: btn };
    var a = el.closest('a[href]');
    if (a && /\/checkouts?(\/|\?|$)/.test(a.getAttribute('href') || '')) return { tipo: 'link', el: a };
    return null;
  }

  var lasciaPassare = false;

  // Fase di cattura: prima dei gestori del tema.
  document.addEventListener(
    'click',
    function (e) {
      if (lasciaPassare) return;
      var t = versoCheckout(e.target);
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      togli().then(function () {
        if (t.tipo === 'link') {
          window.location.href = t.el.href;
          return;
        }
        lasciaPassare = true;
        t.el.click();
        lasciaPassare = false;
      });
    },
    true
  );

  togli();
})();
